import { render, staticRenderFns } from "./orderMealSuccess.vue?vue&type=template&id=03c1351e&scoped=true&"
import script from "./orderMealSuccess.vue?vue&type=script&lang=js&"
export * from "./orderMealSuccess.vue?vue&type=script&lang=js&"
import style0 from "./orderMealSuccess.vue?vue&type=style&index=0&id=03c1351e&prod&lang=less&scoped=true&"
import style1 from "./orderMealSuccess.vue?vue&type=style&index=1&id=03c1351e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1351e",
  null
  
)

export default component.exports